"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var MenuContext_1 = require("./MenuContext");
var MenuListItem_1 = require("./MenuListItem");
var ga_1 = require("../../utils/ga");
// Created to take care of the functionality aspect of MenuListItem
// by implemnting onClick func
var MenuListItemWrapper = function (_a) {
    var menuItem = _a.menuItem, otherNav = _a.otherNav;
    var _b = (0, hooks_1.useContext)(MenuContext_1.default), handleSlide = _b.handleSlide, setSubMenu = _b.setSubMenu;
    var onClick = function () {
        var _a;
        // If at least one item within is collection type, open sub menu when clicked.
        // Otherwise, either go to the link or anchor
        if (((_a = menuItem.items) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
            menuItem.items.some(function (item) { return item.type === 'PRODUCT'; }) &&
            menuItem.items.every(function (item) { return item.type !== 'HTTP'; })) {
            (0, ga_1.sendEvent)('ce_nav_click_category');
            setSubMenu(menuItem);
        }
        else if (menuItem.url) {
            var targetUrl = new URL(menuItem.url);
            if (String(targetUrl).includes('collections')) {
                if (String(targetUrl).includes('shop-all') || String(targetUrl).includes('bundles')) {
                    (0, ga_1.sendEvent)('ce_nav_click_shop_all');
                }
                else {
                    (0, ga_1.sendEvent)('ce_nav_click_category');
                }
            }
            // If target URL is hash on the same page, close the menu & anchor to the hash
            if (targetUrl.hash && targetUrl.pathname === location.pathname) {
                handleSlide(null);
                // ref: https://stackoverflow.com/questions/7831437/location-hash-only-take-effect-once-in-chrome-and-safari
                location.hash = 'hashThatDoesNotExist';
                location.hash = targetUrl.hash;
            }
            else {
                location.href = targetUrl.pathname + targetUrl.hash;
            }
        }
        else {
            // If none of the above is true, throw error and return empty TSX
            console.error("This menu item \"".concat(menuItem.title, "\" does not have children nor destination URL"));
        }
    };
    return ((0, preact_1.h)(preact_1.Fragment, null,
        (0, preact_1.h)(MenuListItem_1.default, { menuItem: menuItem, onClick: onClick, otherNav: otherNav })));
};
exports.default = MenuListItemWrapper;
